class PredictiveSearch extends HTMLElement {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.input = this.querySelector('input[type="search"]')),
      (this.predictiveSearchResults = this.querySelector(
        "[data-predictive-search]"
      )),
      (this.isOpen = !1),
      this.setupEventListeners();
  }
  setupEventListeners() {
    let t = this.querySelector("form.search");
    t.addEventListener("submit", this.onFormSubmit.bind(this)),
      this.input.addEventListener(
        "input",
        this.debounce((t) => {
          this.onChange(t);
        }, 300).bind(this)
      ),
      this.input.addEventListener("focus", this.onFocus.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.addEventListener("keyup", this.onKeyup.bind(this)),
      this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    let t = this.getQuery();
    if (!t.length) {
      this.close(!0);
      return;
    }
    this.getSearchResults(t);
  }
  onFormSubmit(t) {
    (!this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')) &&
      t.preventDefault();
  }
  onFocus() {
    let t = this.getQuery();
    t.length &&
      ("true" === this.getAttribute("results")
        ? this.open()
        : this.getSearchResults(t));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onKeyup(t) {
    switch (
      (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
    ) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
    }
  }
  onKeydown(t) {
    ("ArrowUp" === t.code || "ArrowDown" === t.code) && t.preventDefault();
  }
  switchOption(t) {
    if (!this.getAttribute("open")) return;
    let e = "up" === t,
      i = this.querySelector('[aria-selected="true"]'),
      s = this.querySelectorAll("li"),
      r = this.querySelector("li");
    (!e || i) &&
      ((this.statusElement.textContent = ""),
      !e && i
        ? (r = i.nextElementSibling || s[0])
        : e && (r = i.previousElementSibling || s[s.length - 1]),
      r !== i &&
        (r.setAttribute("aria-selected", !0),
        i && i.setAttribute("aria-selected", !1),
        this.setLiveRegionText(r.textContent),
        this.input.setAttribute("aria-activedescendant", r.id)));
  }
  selectOption() {
    let t = this.querySelector(
      '[aria-selected="true"] a, [aria-selected="true"] button'
    );
    t && t.click();
  }
  getSearchResults(t) {
    let e = t.replace(" ", "-").toLowerCase();
    if ((this.setLiveRegionLoadingState(), this.cachedResults[e])) {
      this.renderSearchResults(this.cachedResults[e]);
      return;
    }
    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        t
      )}&${encodeURIComponent("resources[type]")}=product&${encodeURIComponent(
        "resources[limit]"
      )}=4&section_id=predictive-search`
    )
      .then((t) => {
        if (!t.ok) {
          var e = Error(t.status);
          throw (this.close(), e);
        }
        return t.text();
      })
      .then((t) => {
        let i = new DOMParser()
          .parseFromString(t, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        (this.cachedResults[e] = i), this.renderSearchResults(i);
      })
      .catch((t) => {
        throw (this.close(), t);
      });
  }
  setLiveRegionLoadingState() {
    (this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText =
        this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", !0);
  }
  setLiveRegionText(t) {
    this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = t),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1e3);
  }
  renderSearchResults(t) {
    (this.predictiveSearchResults.innerHTML = t),
      this.setAttribute("results", !0),
      this.setLiveRegionResults(),
      this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"),
      this.setLiveRegionText(
        this.querySelector("[data-predictive-search-live-region-count-value]")
          .textContent
      );
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight -
        document
          .getElementById("shopify-section-header")
          .getBoundingClientRect().bottom),
      this.resultsMaxHeight
    );
  }
  debounce(func, wait) {
    let timeout;

    return function (...args) {
      const context = this;

      const later = function () {
        timeout = null;
        func.apply(context, args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  open() {
    (this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`),
      this.setAttribute("open", !0),
      this.input.setAttribute("aria-expanded", !0),
      (this.isOpen = !0);
  }
  close(t = !1) {
    t && ((this.input.value = ""), this.removeAttribute("results"));
    let e = this.querySelector('[aria-selected="true"]');
    e && e.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", !1),
      (this.resultsMaxHeight = !1),
      this.predictiveSearchResults.removeAttribute("style"),
      (this.isOpen = !1);
  }
}
customElements.define("predictive-search", PredictiveSearch);
